module.exports = __webpack_public_path__ + "static/media/a.dd0df8ec.jpg";